var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    [
      _c("vs-col", { attrs: { "vs-w": "12" } }, [
        _c("h3", [_vm._v(" Mantenedor de Documentos ")]),
        _c("div", { staticClass: "margin-top" }, [
          _c("br"),
          _vm._v(
            "Estas opciones activas aparecerán en los formularios de la aplicación. "
          )
        ]),
        _vm.mantenedorDocumentos && !_vm.mantenedorDocumentos.length
          ? _c("div", [
              _c("h5", { staticClass: "info-documents" }, [
                _vm._v(" Pulsa el botón "),
                _c(
                  "span",
                  { staticStyle: { padding: "0 4px" } },
                  [
                    _c("vs-button", {
                      staticClass: "margin-right",
                      attrs: {
                        color: "primary",
                        size: "small",
                        disabled: "",
                        type: "border",
                        icon: "search"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" para ver los documentos de la categoría ")
              ])
            ])
          : _vm._e()
      ]),
      _c(
        "vs-col",
        { attrs: { "vs-lg": "12", id: "listado-opciones" } },
        [
          _c(
            "vs-row",
            {
              attrs: {
                "vs-type": "flex",
                "vs-align": "space-around",
                "vs-justify": "space-around"
              }
            },
            [
              _c(
                "vs-col",
                {
                  staticClass: "margin-top",
                  attrs: { "vs-sm": "12", "vs-lg": "6" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "add-new" },
                    [
                      _c("h4", [_vm._v("Categorías")]),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED028" } },
                        [
                          _c("vs-button", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Agregar categoría",
                                expression: "'Agregar categoría'"
                              }
                            ],
                            staticClass: "margin-right",
                            attrs: {
                              color: "primary",
                              type: "border",
                              icon: "playlist_add",
                              "data-cy": "create-option"
                            },
                            on: {
                              click: function($event) {
                                return _vm.createOption()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "vs-list",
                    { staticClass: "bg-white margin-top box-options" },
                    _vm._l(_vm.mantenedorCategorias, function(category) {
                      return _c(
                        "div",
                        {
                          key: category.opcionId,
                          staticClass: "wrap-list-item",
                          attrs: { "data-cy": "doc-type" }
                        },
                        [
                          _c("ListItemOption", {
                            attrs: {
                              option: Object.assign({}, category),
                              type: "category",
                              selectedCategory:
                                _vm.selectedCategory &&
                                _vm.selectedCategory.opcionId ===
                                  category.opcionId
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              ),
              _c(
                "vs-col",
                {
                  staticClass: "margin-top",
                  attrs: { "vs-sm": "12", "vs-lg": "6" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "add-new" },
                    [
                      _c("h4", [_vm._v("Documentos")]),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED031" } },
                        [
                          _vm.selectedCategory.opcionId
                            ? _c("vs-button", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Agregar documento a categoría",
                                    expression:
                                      "'Agregar documento a categoría'"
                                  }
                                ],
                                staticClass: "margin-right",
                                attrs: {
                                  color: "primary",
                                  type: "border",
                                  icon: "playlist_add"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.createOption(
                                      _vm.selectedCategory
                                    )
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.mantenedorDocumentos && _vm.mantenedorDocumentos.length
                    ? _c(
                        "vs-list",
                        { staticClass: "bg-white margin-top box-options" },
                        _vm._l(_vm.mantenedorDocumentos, function(document) {
                          return _c(
                            "div",
                            {
                              key: document.opcionId,
                              staticClass: "wrap-list-item"
                            },
                            [
                              _c("ListItemOption", {
                                attrs: {
                                  option: document,
                                  type: "document",
                                  usersCompany: _vm.usersCompany,
                                  groupsCompany: _vm.groupsCompany,
                                  category: _vm.selectedCategory
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "createMood",
          attrs: {
            title: _vm.createDocument ? "Nuevo Documento " : "Nueva Categoría ",
            "hide-footer": "",
            centered: "",
            "no-close-on-backdrop": "",
            size: "lg"
          }
        },
        [
          _c("ManageOption", {
            attrs: {
              option: _vm.option,
              type: _vm.createDocument ? "document" : "category"
            },
            on: { "save-option": _vm.saveOption }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }